import { render, staticRenderFns } from "./TaskS.vue?vue&type=template&id=5d128614&scoped=true"
import script from "./TaskS.vue?vue&type=script&lang=ts"
export * from "./TaskS.vue?vue&type=script&lang=ts"
import style0 from "./TaskS.vue?vue&type=style&index=0&id=5d128614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d128614",
  null
  
)

export default component.exports